import { __decorate } from "tslib";
import { Component, Prop, Vue } from 'vue-property-decorator';
let CardSet = class CardSet extends Vue {
};
__decorate([
    Prop(Array)
], CardSet.prototype, "cards", void 0);
CardSet = __decorate([
    Component
], CardSet);
export default CardSet;
